import IMask from 'imask'
export default class Input {
	constructor (input, page) {
		this.input = input
		this.eventHandlers = page.validator.eventHandlers
		this.pageClass = page
		this.name = input.name
		this.uploader = this.input.hasAttribute('uploader')
		this.createErrorSchema()
		this.setPattern(this.input.getAttribute('data-pattern'))
		this.setMask(this.input.getAttribute('data-mask'))
		this.wasChanged = this.input.hasAttribute('data-validate-always')
		this.registerEvent()
		this.DEFAULT_CLASS_NAME = 'error'
	}

	setPattern (pattern) {
		if (!pattern || pattern == '') return
		var mod = /[g|i|m]{1,3}$/
		var flag = pattern.match(mod)
		flag = flag ? flag[0] : ''
		pattern = pattern.replace(mod, '').slice(1, -1)
		pattern = new RegExp(pattern, flag)
		this.mask = IMask(this.input, {mask: pattern})
	}
	setMask (pattern) {
		if (!pattern || pattern == '') return
		this.mask2 = IMask(this.input, {mask: pattern})
	}

	getValue () {
		if (this.input.type === 'text') {
			return this.input.value
		} else if (this.input.type === 'checkbox') return this.input.checked
		else if (this.input.type === 'radio') return this.input.checked
		else if (this.input.type === 'file') {
			if (this.input.hasAttribute('uploader')) {
				return null
			} else return this.input.files
		}
		return this.input.value
	}
	getUploaderValues (Page, inputvalue) {
		if (!this.uploader) {
			return inputvalue
		}
		var uploader = this.pageClass.validator.filelist[this.name]
		if (!uploader) return inputvalue
		var files = uploader.getValue()
		let _inputvalue = inputvalue
		files.forEach(function (value, key) {
			Page.schema[uploader.config.name + key] = uploader.config.validate
			_inputvalue[uploader.config.name + key] = value
		})
		return _inputvalue
	}

	createErrorSchema () {
		let wrappers = [...this.pageClass.pageElement.querySelectorAll('[data-error="' + this.name + '"]')]
		let textWrappers = []
		let classWrappers = [];
		[...wrappers].forEach(element => {
			if (element.hasAttribute('data-error-class')) {
				classWrappers.push({
					element,
					className: element.dataset['errorClass'] || this.DEFAULT_CLASS_NAME
				})
			}
			if (element.hasAttribute('data-error-text')) { textWrappers.push(element) }
		})
		this.classWrappers = classWrappers
		this.textWrappers = textWrappers
	}

	onErrorsChanged (validBeforeSubmit) {
		if (validBeforeSubmit === true) {
			this.wasChanged = true
		}

		if (this.hasErrors()) { this.showErrors() } else { this.hideErrors() }
	}

	showErrors () {
		[...this.classWrappers].forEach(wrapper => {
			this.eventHandlers.toogleWrapperClass(wrapper, true)
		});
		[...this.textWrappers].forEach(wrapper => {
			let errors = this.pageClass.errors.get(this.name)
			this.eventHandlers.printErrorsText(wrapper, errors)
		})
	}

	hideErrors () {
		[...this.classWrappers].forEach(wrapper => {
			this.eventHandlers.toogleWrapperClass(wrapper, false)
		});

		[...this.textWrappers].forEach(wrapper => {
			this.eventHandlers.removeErrorsText(wrapper)
		})
	}

	hasErrors () {
		const errorsBag = this.pageClass.errors
		const name = this.name
		if (this.uploader && this.pageClass.validator.filelist[this.name]) {
			this.pageClass.validator.filelist[this.name].hasErrors(errorsBag)
		}
		if (errorsBag.has(name) && this.wasChanged) { return true }
		return false
	}

	registerEvent () {
		this.input.addEventListener('keyup', this.usedField.bind(this))
		this.input.addEventListener('keydown', this.usedField.bind(this))
		this.input.addEventListener('click', this.usedField.bind(this))
		this.input.addEventListener('focus', this.usedField.bind(this))
		this.input.addEventListener('change', this.usedField.bind(this))

		this.input.addEventListener('keyup', this.pageClass.validateInput.bind(this.pageClass))
		this.input.addEventListener('keydown', this.pageClass.validateInput.bind(this.pageClass))
		this.input.addEventListener('click', this.pageClass.validateInput.bind(this.pageClass))
		this.input.addEventListener('focus', this.pageClass.validateInput.bind(this.pageClass))
		this.input.addEventListener('input', this.pageClass.validateInput.bind(this.pageClass))
		this.input.addEventListener('change', this.pageClass.validateInput.bind(this.pageClass))
	}

	usedField () {
		if (!this.wasChanged) { this.wasChanged = true }
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/validation/Input.js